module.exports = __webpack_public_path__ + "static/media/omologies_pisteos_pl.3af9f12e.png";